import React, { PureComponent } from "react";
import VerticalSpace from "./components/VerticalSpace";
// import ButtonAppBar from "./components/ButtonAppBar";
import Grid from "@material-ui/core/Grid";
// import Button from "@material-ui/core/Button";
import { Route } from "react-router-dom";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import renderRadioButtonField from "../../components/form/RadioButton";
import { Field, reduxForm } from "redux-form";
import AppConfig from "../../config/appconfig.json";
import KBELogo from "../account/img/kbe-Logo-66454.png";
import PaypalPaymentModule from "../../components/payment/PaypalPaymentModule";
import NetsPaymentModule from "../../components/NetsPaymentModule";

class InvPayment extends PureComponent {
  constructor(props) {
    super(props);
    const inv = this.props.location.state
      ? this.props.location.state.invoice
      : null;
    let amountStr = this.props.location.state
      ? this.props.location.state.invoice.Amount : "";
    amountStr = amountStr.replace('$', '');
    let amountFloat = parseFloat(amountStr);
    this.state = {
      invoice: inv,
      METHOD_ENET: "0",
      METHOD_PAYPAL: "1",
      METHOD_ENET_TEXT: "eNETS",
      METHOD_PAYPAL_TEXT: "Paypal",
      paymentmethod: 0,
      isShowPaypalButton: false,
      amount: amountFloat
    };
    this.handleChangePaymentMethod = this.handleChangePaymentMethod.bind(this);
    this.handleInvoicePayment = this.handleInvoicePayment.bind(this);
    //console.log(inv);
  }

  handleChangePaymentMethod(e) {
    // console.log(e[0]);
    this.setState({ paymentmethod: e[0], isShowPaypalButton: e[0] === this.state.METHOD_PAYPAL });
  }

  handleProceed(event) {
    event.preventDefault();

    // console.log("form submitted");
  }

  handleInvoicePayment(history, data) {
    if (this.state.invoice) {
      let isInvoicePayment = false;
      const request = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          InvoiceSid: this.state.invoice.InvoiceSid,
          Amount: this.state.invoice.Amount,
          PromoCode: "",
          PaymentMode: this.state.paymentmethod === this.state.METHOD_ENET ? this.state.METHOD_ENET_TEXT : this.state.METHOD_PAYPAL_TEXT
        })
      };
      // Call Back-End Services
      fetch(`${AppConfig.BACK_END_URL}/APIClient/InvoicePayment`, request)
        .then(response => {
          // console.log(response);
          if (response.ok === false) {
            isInvoicePayment = true;
          }
          return response.json();
        })
        .then(json => {
          if (isInvoicePayment) {
          } else {
            const respObj = JSON.parse(json);
            console.log(respObj);
            if (respObj) {
              history.push({ pathname: "/inv_confirmation", state: { invoice: this.state.invoice } });
            }
          }
        })
        .catch(() => {
          console.log(
            "Something went wrong when submitting invoice payment. Please try again."
          );
        });
    }
  }

  render() {
    // const ProceedButton = props => (
    //   <Route
    //     render={({ history }) => (
    //       <div>
    //         <Button
    //           variant="outlined"
    //           style={{ width: "100%" }}
    //           onClick={() => {
    //             this.handleInvoicePayment(history);
    //           }}
    //         >
    //           Proceed
    //         </Button>
    //       </div>
    //     )}
    //   />
    // );

    return (
      <div>
        {/* <ButtonAppBar /> */}
        <div className="account">
          <div className="account__wrapper">
            <div className="account__card">
              <div className="account__head">
                <img src={KBELogo} alt="logo" />
              </div>
              <div className="card__title">
                <center>
                  <h4 className="bold-text">Payment</h4>
                </center>
                <br />
              </div>
              <form
                className="form form--horizontal"
                onSubmit={this.handleProceed}
              >
                <div className="form__form-group">
                  <label className="form__form-group-label">Invoice </label>
                  <div className="form__form-group-field">
                    <label className="form__form-group-label">{this.state.invoice.InvoiceNumber}</label>
                  </div>
                </div>
                <div className="form__form-group">
                  <label className="form__form-group-label">
                    Payment Due:{" "}
                  </label>
                  <div className="form__form-group-field">
                    <label className="form__form-group-label">{this.state.invoice.PaymentDue}</label>
                  </div>
                </div>
                <div className="form__form-group">
                  <label className="form__form-group-label">Amount: </label>
                  <div className="form__form-group-field">
                    <label className="form__form-group-label">{this.state.invoice.Amount}</label>
                  </div>
                </div>
                <div className="form__form-group">
                  <label className="form__form-group-label">
                    Payment Option
                  </label>
                  <div className="form__form-group-field">
                    {this.state.invoice.PaymentModes === "NETS/Paypal" || this.state.invoice.PaymentModes === "NETS" ?
                      <Field
                        name="paymentoption"
                        component={renderRadioButtonField}
                        label={this.state.METHOD_ENET_TEXT}
                        radioValue={this.state.METHOD_ENET}
                        onChange={this.handleChangePaymentMethod}
                        defaultChecked
                      />
                      : null}
                    {this.state.invoice.PaymentModes === "NETS/Paypal" || this.state.invoice.PaymentModes === "Paypal" ?
                      <Field
                        name="paymentoption"
                        component={renderRadioButtonField}
                        label={this.state.METHOD_PAYPAL_TEXT}
                        radioValue={this.state.METHOD_PAYPAL}
                        onChange={this.handleChangePaymentMethod}
                      />
                      : null}
                  </div>
                </div>
                <div className="form__form-group">
                  <Grid container spacing={24}>
                    <Grid item xs={3} />
                    <Grid item xs={6}>
                      {this.state.isShowPaypalButton ? (
                        <Route
                          render={({ history }) => (
                            <PaypalPaymentModule isShowPaypalButton={this.state.isShowPaypalButton}
                              totalAmount={this.state.amount} customerType={this.state.invoice.CustomerType} onPaymentSuccess={(data) => {
                                // console.log("Paypal payment received");
                                // console.log(data);
                                this.handleInvoicePayment(history, data);
                              }}></PaypalPaymentModule>)}
                        />) : (
                          this.state.invoice.PaymentModes === "NETS/Paypal" || this.state.invoice.PaymentModes === "NETS" ?
                            <NetsPaymentModule txnAmount={this.state.amount} requestForm={this.state.invoice} isInvoicePayment={true} />
                            : null
                          // <span></span>
                          //<ProceedButton />
                          // <ProceedButtonPaypal />
                        )}
                    </Grid>
                    <Grid item xs={3} />
                  </Grid>
                  <VerticalSpace />
                </div>
              </form>
              <SimpleBottomNavigation value={3} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: "payment_form" // a unique identifier for this form
})(InvPayment);



// WEBPACK FOOTER //
// ./src/pages/main/InvPayment.js